const optionDate = {
  year: "numeric",
  month: "numeric",
  day: "numeric"
};

const optionDateShort = {
  month: "numeric",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit"
};

const optionTimeHours = {
  hour: "2-digit",
  minute: "2-digit"
};

const optionDateTime = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit"
};

const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function timeMillisToHoursMinutesString(millis) {
  let _millis = millis * 1000;
  let baseTime = new Date(_millis);
  let translatedTime =
    "" +
    baseTime.getHours().toLocaleString("nl-NL", {
      minimumIntegerDigits: 2
    }) +
    ":" +
    baseTime.getMinutes().toLocaleString("nl-NL", {
      minimumIntegerDigits: 2
    });
  return translatedTime;
}

function timeSecToHoursMinutesString(sec) {
  let _sec = sec;
  let baseTime = new Date(_sec);
  let translatedTime =
    "" +
    baseTime.getHours().toLocaleString("nl-NL", {
      minimumIntegerDigits: 2
    }) +
    ":" +
    baseTime.getMinutes().toLocaleString("nl-NL", {
      minimumIntegerDigits: 2
    });

  return translatedTime;
}

function stringToSeconds(stringTime) {
  let arrayTime = stringTime.split(":");
  let _convertedMinute = Number(arrayTime[1]) + Number(arrayTime[0]) * 60;
  return _convertedMinute;
}

function stringToTimeMillis(stringTime, currentDate = null) {
  let baseTime = "";
  if (typeof stringTime === "undefined") {
    return baseTime;
  }
  if (typeof currentDate == "undefined") {
    baseTime = new Date();
  } else {
    baseTime = new Date(currentDate);
  }
  let arrayTime = stringTime.split(":");
  baseTime.setHours(Number(arrayTime[0]), Number(arrayTime[1]));
  let translatedTime = Math.round(baseTime.getTime() / 1000);
  return translatedTime;
}

function wait(ms) {
  var start = new Date().getTime();
  var end = start;
  while (end < start + ms) {
    end = new Date().getTime();
  }
}

function toBeRemoved(aspect) {
  let toBeRemoved = true;
  switch (aspect.Type.value) {
    case "USER":
      toBeRemoved = false;
      break;
    default:
      break;
  }

  return toBeRemoved;
}

function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
  let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return { width: srcWidth*ratio, height: srcHeight*ratio };
}

function isAspectAllowedForUser(aspect) {
  let status = false;
  switch (aspect.Type.value) {
    case "TestAspect03":
    case "TestAspect":
    case "BusStop":
    case "Bus":
    case "TrafficJam":
    case "Accident":
    case "RoadWork":
    case "EmergencyService":
    case "RoadRelation":
    case "INCIDENT":
    case "Incident":
    case "ParkingFacility":
    case "IVERA_VRI_BRIDGE":
    case "DisperantoDisplay":
    case "PRISDisplayManager":
    case "Camera":
    case "EntryPoint":
    case "USER":
      status = true;
      break;
    case "AreaManager":
      if (
        aspect.DataFieldTable.hasOwnProperty("UserPermission") ||
        aspect.DataFieldTable.hasOwnProperty("UserGroupPermission")
      ) {
        status = true;
      }
      break;
    default:
      console.error(
        "isAspectAllowedForUser aspect type not supported",
        aspect.Type.value,
        aspect
      );
      break;
  }
  return status;
}

// specific to map TagId = TagId
const arrayToObject = array =>
  array.reduce((obj, item) => {
    obj[item] = item;
    return obj;
  }, {});

const objectToArray = object => {
  let a = [];
  for (const [k, v] of Object.entries(object)) {
    a.push({ ...v });
  }
  return a;
};

const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const map = (fn, params) => {
  // params === undefined ? [] : [fn(params), ...map(fn, params)];
};

// const recursiveFilter = (pred, [head, ...tail]) => {
//   if(head === undefined) return [];
//   debugger;
//   if(pred(head.name)) {
//     return [head, ...recursiveFilter(pred, tail)];
//   }
//   debugger;
//   return [...recursiveFilter(pred, tail)];
// };

/**
 * @param {string} dateYMD 2020-09-20
 * @returns {string} dateDMY 20-09-2020
 */
function dateFromYMDToDMY(dateYMD) {
  // Date from 2020-09-20 to 20-09-2020
  if (dateYMD == null || dateYMD === '') {
    return '';
  }

  const [year, month, day] = dateYMD.split('-');
  const dateDMY = `${day}-${month}-${year}`;
  return dateDMY;
}

/**
 * @param {string} dateDMY 20-09-2020
 * @returns {string} dateYMD 2020-09-20
 */
function dateFromDMYToYMD(dateDMY) {
  // Date from 20-09-2020 to 2020-09-20
  if (dateDMY == null || dateDMY === '') {
    return '';
  }

  const [day, month, year] = dateDMY.split('-');
  const dateYMD = `${year}-${month}-${day}`;
  return dateYMD;
}

/**
 * @param {string} dateTimeStr format: dd-mm-yyyy hh:mm
 */
function getDateTimeInt(dateTimeStr) {
  const dateTimeTrimed = dateTimeStr.trim();
  const [dateStr, timeStr] = dateTimeTrimed.split(' ');
  const dateYMD = dateFromDMYToYMD(dateStr);
  let dateTimeArg = '';
  if (dateYMD != null) {
    dateTimeArg += dateYMD;
  }
  if (timeStr != null) {
    if (dateTimeArg !== '') {
      dateTimeArg += `T${timeStr}`;
    } else {
      dateTimeArg += timeStr;
    }
  }
  let dateTimeInt = 0;
  if (dateTimeArg !== '') {
    const date = new Date(dateTimeArg);
    dateTimeInt = date.getTime();
  }

  return dateTimeInt;
}

/**
 * @param {String} dateTimeA format: dd-mm-yyyy hh:mm
 * @param {String} dateTimeB format: dd-mm-yyyy hh:mm
 */
function dateTimeCompare(dateTimeA, dateTimeB) {
  const dateIntA = getDateTimeInt(dateTimeA);
  const dateIntB = getDateTimeInt(dateTimeB);

  if (dateIntA < dateIntB) {
    return -1;
  }

  if (dateIntA > dateIntB) {
    return 1;
  }

  return 0;
}

export {
  optionDate,
  optionTimeHours,
  optionDateTime,
  optionDateShort,
  toBeRemoved,
  isAspectAllowedForUser,
  timeSecToHoursMinutesString,
  timeMillisToHoursMinutesString,
  stringToTimeMillis,
  stringToSeconds,
  wait,
  arrayToObject,
  objectToArray,
  weekdays,
  calculateAspectRatioFit,
  map,
  groupBy,
  dateTimeCompare,
  dateFromDMYToYMD,
  dateFromYMDToDMY,
  // groupBy,
  // recursiveFilter
};
